import { render } from "./WpeHealth.vue?vue&type=template&id=7c042e28"
import script from "./WpeHealth.vue?vue&type=script&lang=js"
export * from "./WpeHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WpeHealth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c042e28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c042e28', __exports__)) {
    api.reload('7c042e28', __exports__)
  }
  
  module.hot.accept("./WpeHealth.vue?vue&type=template&id=7c042e28", () => {
    api.rerender('7c042e28', render)
  })

}


export default __exports__